import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const links = [
    { to: "/", label: t.nav.home, id: "home" },
    { to: "/servizi", label: t.nav.servizi, id: "servizi" },
    { to: "/team", label: t.nav.team, id: "team" },
    { to: "/contatti", label: t.nav.contatti, id: "contatti" },
  ];

  return (
    <footer className="bg-night text-sand" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <Logo dark />
            <p className="mt-6 max-w-md text-sm leading-relaxed text-sand/60">
              {t.footer.blurb}
            </p>
            <p className="mt-4 font-serif text-lg italic text-gold">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-mono text-xs uppercase tracking-[0.24em] text-terra">
              {t.footer.browse}
            </h3>
            <ul className="mt-5 space-y-3">
              {links.map((l) => (
                <li key={l.id}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.id}`}
                    className="text-sm font-semibold text-sand/80 transition-colors duration-200 hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-mono text-xs uppercase tracking-[0.24em] text-terra">
              {t.footer.contact}
            </h3>
            <ul className="mt-5 space-y-3 text-sm font-semibold text-sand/80">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-gold" />
                <a
                  href="mailto:info@swmconsulting.it"
                  data-testid="footer-email-link"
                  className="transition-colors duration-200 hover:text-gold"
                >
                  info@swmconsulting.it
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-sand/10 pt-8 text-xs text-sand/40 md:flex-row md:items-center md:justify-between">
          <span data-testid="footer-rights">{t.footer.rights}</span>
          <span className="font-mono uppercase tracking-[0.2em]">SWM Consulting</span>
        </div>
      </div>
    </footer>
  );
}
